import {buildRelativeURL} from '../../../../helper';
import productPrice from './tile-box/product-price';

/**
 * @param {Array<Object>} swatches - product swatches
 * @returns {string} product swatches HTML
 */
export default swatches => {
    if (swatches?.length > 0) {
        return `
            <div class="product-color-swatches">
                <ul class="color-swatch-list ${swatches.length <= 5 ? 'center-mode' : ''}">
                    ${swatches
                        .map(swatch => {
                            const thumb = {
                                src: swatch.thumbImage.url,
                                alt: swatch.thumbImage.title,
                                title: swatch.thumbImage.title
                            };

                            return `
                                <li>
                                    <a href="${buildRelativeURL(swatch.swatchProductURL)}"
                                        class="color-swatch ${
                                            window.SitePreferences.ENABLE_MOBILE_SWATCH_SELECTION
                                                ? 'mobile-selectable'
                                                : ''
                                        } ${swatch.preselectCurrentSwatch ? 'selected' : ''}"
                                        title="${swatch.swatchImage.title}"
                                        data-flags='${swatch.flags}'
                                        data-thumb='${JSON.stringify(thumb)}'
                                        data-product-id="${swatch.productID}"
                                        data-hover-container=".tile-swatch"
                                        data-color="${swatch.colorName}"
                                        data-price-container='${productPrice(
                                            swatch.priceInfo ? JSON.parse(swatch.priceInfo) : {noprice: true}
                                        )}'>
                                            <img class="color-swatch-image" src="${swatch.swatchImage.url}"
                                                alt="${swatch.swatchImage.title}" />
                                    </a>
                                </li>
                            `;
                        })
                        .join('')}
                </ul>
            </div>
        `;
    }

    return '';
};
